import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import {
  RESOURCE_POST_PATHNAME,
  RESOURCE_TAG_PATHNAME,
  RESOURCES_PATHNAME,
} from '@glass/common/modules/pages/paths';

import Link from '@glass/shared/components/Link/Link';

const ResourceLink = React.forwardRef(
  (
    { children, target, tag, slug, shallow, className, style, onClick, onMouseEnter, onMouseLeave },
    ref,
  ) => {
    const href = useMemo(() => {
      let pathname = RESOURCES_PATHNAME;
      let query = null;

      if (slug) {
        pathname = RESOURCE_POST_PATHNAME;
        query = { slug };
      } else if (tag) {
        pathname = RESOURCE_TAG_PATHNAME;
        query = { tag };
      }

      return {
        pathname,
        query,
      };
    }, [slug, tag]);
    return (
      <Link
        ref={ref}
        className={className}
        href={href}
        shallow={shallow}
        style={style}
        target={target}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </Link>
    );
  },
);

ResourceLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  shallow: PropTypes.bool,
  slug: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  tag: PropTypes.string,
  target: PropTypes.string,
};

ResourceLink.displayName = 'ResourceLink';

export default React.memo(ResourceLink);
